import { useEffect, useState } from 'react';

interface Props {
  value: number;
  unitCode?: string | null;
  onCommit: (value: number) => void;
}

/**
 * Celda de cantidad editable directamente en la tabla — guarda al perder
 * foco (o Enter) solo si el valor cambió y es válido; si no, revierte.
 */
const EditableQuantityCell = ({ value, unitCode, onCommit }: Props) => {
  const [local, setLocal] = useState(String(value));

  useEffect(() => {
    setLocal(String(value));
  }, [value]);

  const commit = () => {
    const num = Number(local);
    if (!Number.isNaN(num) && num > 0 && num !== value) {
      onCommit(num);
    } else {
      setLocal(String(value));
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        type="number"
        min={0.01}
        step="0.01"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        }}
        className="w-24 rounded border border-stroke bg-white px-2 py-1 text-sm text-black outline-none focus:border-primary dark:border-strokedark dark:bg-meta-4 dark:text-white"
      />
      {unitCode && (
        <span className="text-xs text-gray-500 dark:text-gray-400">{unitCode}</span>
      )}
    </div>
  );
};

export default EditableQuantityCell;
